import hatStyles from "../1-style/hatStyles";
import { clickOnMaterialElement } from "../2-material/clickOnMaterialElement";
import selectAllElements from "../dom/selectAllElements";
import { CHOOSE_HAT_COLOR } from "./_selectors";
import disableSwatches from "./disableSwatches";

function chooseHatSetup() {
	const chooseHatColors = selectAllElements<HTMLSpanElement>(CHOOSE_HAT_COLOR);
	if (chooseHatColors !== null) {
		const defaultSwatch = `${hatStyles.snapback.materials.wool.name} - $${hatStyles.snapback.materials.wool.price}`;
		clickOnMaterialElement(defaultSwatch);
		console.log("defaultSwatch", defaultSwatch);
		disableSwatches(defaultSwatch);
	}
}

export default chooseHatSetup;
